import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import { parseJSON } from '../../utils/helpers';

const CreateRule = () => {
  const dispatch = useDispatch();
  const { conditions, actions, timeTemplates, ruleCreated, loadingRuleCreated } = useSelector((state) => state.general);

  const [selectedCondition, setSelectedCondition] = useState(undefined);
  const [selectedAction, setSelectedAction] = useState(undefined);
  const [name, setName] = useState('');
  const [frequency, setFrequency] = useState('DAILY');
  const [specificTime, setSpecificTime] = useState([{ hour: 12, minute: 0 }]);
  const [timeTemplateId, setTimeTemplateId] = useState(undefined);

  const handleSpecificTimeChange = (index, field, value) => {
    const newSpecificTime = [...specificTime];
    newSpecificTime[index][field] = value;
    setSpecificTime(newSpecificTime);
  };

  const handleDeleteSpecificTime = (index) => {
    const newSpecificTime = specificTime.filter((_, i) => i !== index);
    setSpecificTime(newSpecificTime);
  };

  useEffect(() => {
    dispatch(apiAction({ reduxField: 'conditions', route: 'conditions/getConditions' }));
    dispatch(apiAction({ reduxField: 'actions', route: 'actions/getActions' }));
    dispatch(
      apiAction({
        reduxField: 'timeTemplates',
        route: 'timeTemplates/getTimeTemplates',
      })
    );
  }, [dispatch]);
  console.log({ selectedCondition, selectedAction, name, frequency, specificTime });

  if (ruleCreated?._id) {
    dispatch(generalSet({ reduxField: 'ruleCreated', value: null }));
    window.location.href = '/rules';
  }

  return Array.isArray(conditions) && Array.isArray(actions) && Array.isArray(timeTemplates) ? (
    <div className='container mt-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center border-bottom'>
        <h1>Create a Rule</h1>
      </div>

      <div className='row d-flex justify-content-center mt-4'>Enter rule name:</div>
      <div className='row d-flex justify-content-center'>
        <div className='col-md-6'>
          <input
            type='text'
            style={{ textAlign: 'center' }}
            className='form-control'
            placeholder='Rule Name'
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
      </div>

      <div className='row d-flex justify-content-center mt-4'>Choose a condition:</div>
      <div className='row d-flex justify-content-center'>
        <Select
          className='col-md-6'
          options={conditions.map((condition) => ({
            value: condition._id,
            label: condition.name,
          }))}
          placeholder='Search or select a condition'
          onChange={(selectedOption) => setSelectedCondition(selectedOption.value)}
          isSearchable
        />
      </div>

      <div className='row d-flex justify-content-center mt-4'>Choose an action:</div>
      <div className='row d-flex justify-content-center'>
        <Select
          className='col-md-6'
          options={actions.map((action) => {
            const actionData = parseJSON(action.actionData);
            return {
              value: action._id,
              label: actionData.name,
            };
          })}
          placeholder='Search or select a action'
          onChange={(selectedOption) => setSelectedAction(selectedOption.value)}
          isSearchable
        />
      </div>

      <div className='row d-flex justify-content-center mt-4'>Choose frequency:</div>
      <div className='row d-flex justify-content-center'>
        <div className='col-md-4'>
          <select
            className='form-control select'
            aria-label='Default select example'
            value={frequency}
            onChange={(e) => setFrequency(e.target.value)}
          >
            <option value='DAILY'>Daily</option>
            <option value='HOURLY'>Hourly</option>
            <option value='HALF_HOURLY'>Half Hourly</option>
            <option value='SPECIFIC_TIME'>Specific Time</option>
            <option value='TIME_TEMPLATE'>Time Template</option>
          </select>
        </div>
      </div>

      {frequency === 'SPECIFIC_TIME' && (
        <div className='row d-flex justify-content-center mt-4'>
          <div className='col-md-12 d-flex justify-content-center'>
            <small>
              <b>Note: </b> All rules are under UTC timzone{' '}
            </small>
          </div>
          <div className='col-md-6'>
            {specificTime.map((time, index) => (
              <div key={index} className='d-flex justify-content-between align-items-center'>
                <select
                  className='form-control'
                  value={time.hour}
                  onChange={(e) => handleSpecificTimeChange(index, 'hour', e.target.value)}
                >
                  {Array.from({ length: 24 }, (_, i) => (
                    <option key={i} value={i}>
                      {i}
                    </option>
                  ))}
                </select>
                <select
                  className='form-control'
                  value={time.minute || 0}
                  onChange={(e) => handleSpecificTimeChange(index, 'minute', e.target.value)}
                >
                  <option value={0}>00</option>
                  <option value={30}>30</option>
                </select>
                <button className='btn btn-outline-danger' onClick={() => handleDeleteSpecificTime(index)}>
                  <i className='fa fa-trash' aria-hidden='true'></i>
                </button>
              </div>
            ))}
            <button
              className='btn btn-outline-dark mt-2'
              onClick={() => setSpecificTime([...specificTime, { hour: '', minute: '' }])}
            >
              Add Time
            </button>
          </div>
        </div>
      )}

      {frequency === 'TIME_TEMPLATE' && (
        <>
          <div className='row d-flex justify-content-center mt-4'>
            <div className='col-md-12 d-flex justify-content-center'>
              <h6>Choose a Template</h6>
            </div>
            <Select
              className='col-md-6'
              options={timeTemplates.map((template) => ({
                value: template._id,
                label: template.name,
              }))}
              placeholder='Search or select a template'
              onChange={(selectedOption) => {
                setTimeTemplateId(selectedOption.value);
              }}
              isSearchable
            />
          </div>
        </>
      )}

      {selectedCondition && selectedAction && name && frequency
        ? (() => {
            if (frequency === 'SPECIFIC_TIME' && specificTime.length === 0) {
              return (
                <div className='row d-flex justify-content-center mt-4'>
                  <h6>Please add a specific time</h6>
                </div>
              );
            }
            if (frequency === 'TIME_TEMPLATE' && !timeTemplateId) {
              return (
                <div className='row d-flex justify-content-center mt-4'>
                  <h6>Please select a time template</h6>
                </div>
              );
            }
            return (
              <>
                <div className='row d-flex justify-content-center mt-4 pt-lg-0' data-aos='fade-up' data-aos-delay='200'>
                  <button
                    className='btn btn-outline-dark'
                    disabled={loadingRuleCreated}
                    onClick={() => {
                      dispatch(generalSet({ reduxField: 'loadingRuleCreated', value: true }));
                      dispatch(
                        apiAction({
                          route: 'rules/createRule',
                          reduxField: 'ruleCreated',
                          name,
                          conditionId: selectedCondition,
                          actionId: selectedAction,
                          frequency,
                          specificTime,
                          timeTemplateId,
                          setLoading: 'loadingRuleCreated',
                        })
                      );
                    }}
                  >
                    Create Rule
                  </button>
                </div>
              </>
            );
          })()
        : null}
    </div>
  ) : (
    <Spinner />
  );
};

export default CreateRule;
